import { RESOURCE } from "./constants"
import ResourceList from "./ResourceList"
import Resource from "./Resource"
import Deck from "./Deck"
import Card from "./Deck"

class GameState {
    constructor({ resources, deck, hand }) {
        this.resources = resources || new ResourceList([
            new Resource({ type: RESOURCE.HEALTH, amount: 10 }),
            new Resource({ type: RESOURCE.SANITY, amount: 10 }),
            new Resource({ type: RESOURCE.SUPPLIES, amount: 10 }),
            new Resource({ type: RESOURCE.FAME, amount: 10 })
        ])
        this.deck = deck || new Deck({})
        this.hand = hand || []
    }

    draw( number = 1 ) {
        const [ drawnCards, newDeck ] = this.deck.draw( number )
        const newHand = this.hand.concat(drawnCards).map(card => new Card({...card}))
        return new GameState({
            ...this,
            deck: newDeck,
            hand: newHand
        })
    }

    get isOver() {
        return (
            this.resources.get(RESOURCE.HEALTH).amount <= 0 ||
            this.resources.get(RESOURCE.SANITY).amount <= 0 ||
            this.resources.get(RESOURCE.SUPPLIES).amount <= 0 ||
            this.resources.get(RESOURCE.FAME).amount <= 0
        )
    }

    get isWon() {
        return (
            this.deck.length < 2
        )
    }
}

export default GameState